import { makeAutoObservable } from 'mobx';
import { AuthType } from '../types';
import Api from '../api/API';

class Auth{
  constructor() {
    makeAutoObservable(this);
  }

  async logout(){
    return await Api<undefined, undefined>().get(`${process.env.REACT_APP_LM_API_URL}/api/${process.env.REACT_APP_API_VERSION}/logout`);
  }
  async auth(credentials: AuthType){
    return await Api<AuthType, string>().get(`${process.env.REACT_APP_LM_API_URL}/api/auth/${process.env.REACT_APP_API_VERSION}/token`, credentials);
  }
}

export const AuthStore = new Auth();
